import { http } from "Utils/http";
import { STATUSES } from "Utils/constants";

// auto ws pwd generator for activation and forgot password
const getGeneratePWD = async () => {

  let status = STATUSES.SUCCESS;

  const url = "/api/activation/generatePwd";
  const res = await http.post(url, {}, {
    headers: {
      //"Authorization": token
    }
  }).then(res => {

    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    //console.log("getGeneratePWD()", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// trigger pwd validation for password creation rules for activation
const validateResetPassword = async (token, pwd) => {

  let status = STATUSES.SUCCESS;
  let body = {
    "password": pwd,
    "resetPasswordToken": token
  };

  const url = "/api/activation/validatePwd";
  const res = await http.post(url, body, {
    headers: {
      //"Authorization": token
    }
  }).then((res) => {

    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {

    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};


// reset password for activation
const submitResetPassword = async (token, formInfo, nameConverter, addErrorMessages, clearErrorMessages, getFieldValue) => {
  //console.log("submitResetPassword() axios", token, formInfo, getFieldValue("conNewPassword", formInfo.data));
  //clearErrorMessages(formInfo.data);

  var request = {
    "newPwd": getFieldValue("newPassword", formInfo.data),
    "confirmPwd": getFieldValue("conNewPassword", formInfo.data),
    "resetPasswordToken": token
  }

  var url = "/api/activation/savePwd";

  var status = STATUSES.SUCCESS;

  const res = await http.post(url, request, {
    headers: {
      //"Authorization": token
    }
  }).then(res => {
    //console.log("submitResetPassword()", res);
    var x = 0;
    var isFirst = false;
    for (const [key, value] of Object.entries(nameConverter)) {

      var d = res.fieldErrors;
      var values = d[key];

      if (values != null) {
        if (x == 0) {
          isFirst = true;
        }
        else {
          isFirst = false;
        }
        addErrorMessages(value, key, res, isFirst);
        status = STATUSES.ERROR;
        x = x + 1;
      }
    }

    return Promise.resolve({ status: status, data: res });

  }).catch(function (error) {
    //console.log("error caught from submitEditWSAccount()", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });
  return res;
};

// Set up Mfa with the phone request
const setupMfa = async (token, request) => {

  let status = STATUSES.SUCCESS;
  let body = {
    "resetPasswordToken": token,
    "mobileNumber": request.mobileNumber
  }

  const url = "/api/activation/setupMfa";
  const res = await http.post(url, body, {
    // headers: {
    //   "Authorization": token
    // }
  }).then((res) => {
    //console.log("setupMfa()", res);
    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// verify the new phone device
const submitMfa = async (token, mfaToken) => {

  let status = STATUSES.SUCCESS;
  /*{
    "resetPasswordToken":token,
    "mfaToken":mfaToken
  }*/
  let body = {
    "resetPasswordToken": token,
    "mfaToken": mfaToken
  }

  const url = "/api/activation/setupMfaVerifyToken";
  const res = await http.post(url, body, {
    // headers: {
    //   "Authorization": token
    // }
  }).then((res) => {
    //console.log("submitMfa()", res);
    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

export { getGeneratePWD, validateResetPassword, submitResetPassword, setupMfa, submitMfa }